module.exports = __webpack_public_path__ + "img/logo.f71ac9fe.png";